import { EventsAPIService } from './events.service';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.services.events', ['sfMobile.services.pov'])
  .service('eventsAPIService', EventsAPIService).name;
